/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const scenarioItemDependencyResponseSchema = z.object({
  id: z.int(),
  predecessorItemId: z.int(),
  successorItemId: z.int(),
  waitDays: z.int().nullish(),
});
